import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import './style.scss';
const ConversationGuide = () => {
  const dispatch = useDispatch();
  const closeConversationGuide = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const [displayStatus, setDisplayStatus] = useState({ help_content: true, guide_content: false, satisfy_content: false });

  // // state
  // const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  // const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // // event
  const changeDisplayHelp = () => {
    setDisplayStatus({ help_content: true, guide_content: false, satisfy_content: false });
  };
  const changeDisplayGuide = () => {
    setDisplayStatus({ help_content: false, guide_content: true, satisfy_content: false });
  };
  const changeDisplaySatisfy = () => {
    setDisplayStatus({ help_content: false, guide_content: false, satisfy_content: true });
  };

  // const setContentValue = contentStr => {
  //   if (contentStr) {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
  //   } else {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
  //   }
  // };
  return (
    <div className="guide_area">
      <div className="guide_header">
        <span>대화 가이드</span>
        <i className="ri-close-line" onClick={closeConversationGuide} />
      </div>
      <div className="guide_tab_area">
        <div
          className="guide_tab"
          onClick={changeDisplayHelp}
          style={{
            borderBottom: displayStatus.help_content ? '4px #3572D3 solid' : '',
            color: displayStatus.help_content ? '#3572D3' : '',
            fontWeight: displayStatus.help_content ? '600' : '400',
          }}
        >
          챗봇 활용
        </div>
        <div
          className="guide_tab"
          onClick={changeDisplayGuide}
          style={{
            borderBottom: displayStatus.guide_content ? '4px #3572D3 solid' : '',
            color: displayStatus.guide_content ? '#3572D3' : '',
            fontWeight: displayStatus.guide_content ? '600' : '400',
          }}
        >
          챗봇 기능
        </div>
        <div
          className="guide_tab"
          onClick={changeDisplaySatisfy}
          style={{
            borderBottom: displayStatus.satisfy_content ? '4px #3572D3 solid' : '',
            color: displayStatus.satisfy_content ? '#3572D3' : '',
            fontWeight: displayStatus.satisfy_content ? '600' : '400',
          }}
        >
          만족도 평가
        </div>
      </div>
      <div className="guide_content" style={{ display: displayStatus.help_content ? 'block' : 'none' }}>
        <div className="guide_title">궁금하신 내용을 챗봇에 질문해보세요!</div>
        <img src="/chat/images/guide01.png" alt="" className="img_help" />
      </div>

      <div className="guide_content guide_content" style={{ display: displayStatus.guide_content ? 'block' : 'none' }}>
        <div className="guide_title">챗봇의 다양한 기능을 활용해보세요!</div>
        <img src="/chat/images/guide02.png" alt="" className="img_help" />
      </div>

      <div className="guide_content satisfy_content" style={{ display: displayStatus.satisfy_content ? 'block' : 'none' }}>
        <div className="guide_title">챗봇 사용 후 의견을 남겨주세요!</div>
        <img src="/chat/images/guide03.png" alt="" className="img_help" />
      </div>
    </div>
  );
};

export default ConversationGuide;
